export const addressPoints = {
  'dPM1': [],
  'dPM10': [],
  'dPM2': [],
  'temp': [],
  'humidity': [],
};
